// The beta's addresses. /beta is the email screen (src/pages/beta/index.tsx)
// and /beta/workspace the tools (src/pages/beta/workspace.tsx): the workspace
// frame with the ES and NQ chart, Volume Profile and DOM.
export const BETA_PATH = "/beta";
export const BETA_WORKSPACE_PATH = "/beta/workspace";
